module.exports = __webpack_public_path__ + "static/media/nytimes.com_2016_05_02_health_biggest-loser-weight-loss.html_plot.505aa663.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/nytimes.com_2016_05_02_health_biggest-loser-weight-loss.html_plot.png
// module id = 405
// module chunks = 0